export default {
  endChat: '结束对话',
  recommend: '热门推荐',
  send: '发送',
  preview: '预览',
  download: '下载',
  unfold: '展开',
  fold: '收起',
  playVideo: '点击播放视频',
  inputQA: '请输入问题',
  goToHuman: '不好意思，我们还是没能理解您的意思，建议点击下方“人工客服”为您提供进一步服务。',
  customerService: '人工客服',
  satisfied: '满意',
  unsatisfied: '不满意',
  more: '换一批',
  clickToman: '点击我转人工',
  feedback: '感谢您的反馈',
  mandarin: '普通话',
  cantonese: '粤语',
  notMediaSupport: '此视频暂无法播放，请稍后再试',
  want: '猜您想问：',
  callEnd: '会话结束',
  reloadCall: '刷新，重新对话',
  ttsFail: '语音合成失败！',
  synthesising: '语音合成中...',
  inSpeechRecognition: '语音识别中...',
  pressToSpeak: '按住说话',
  cancelSend: '取消发送',
  transException: '转文本异常',
  remaining: '{0}秒后停止录音',
  quitTips: '由于长时间未沟通，系统已自动退出',
  timeOutTips: '连接已超时，您可以发送问题重新连接',
  defaultRobot: '智能客服小曼',
  welcome: '你好，请问有什么可以帮您？',
  ttsEmpty: '暂无可播报内容'
}